// List of all weather stations
import Leaflet from 'leaflet';

export function rainfallMarker(rainfall: string): Leaflet.DivIcon {
    if (rainfall === 'M')
    {
        return Leaflet.divIcon({
            className: 'number-icon',
            html: `<div style="background-color: gray; margin: 0px; color:white;">M</div>`,
            iconSize: [21, 25]
          });
    }

    var rainfallFloat:number = parseFloat(rainfall);

    return Leaflet.divIcon({
        className: 'number-icon',
        html: `<div style="background-color: ${setColorOfRainfall(rainfallFloat)}; color:${setColorOfRainfallText(rainfallFloat)}; margin: 0px;">${rainfall}</div>`,
        iconSize: setRainMarkerIconSize(rainfall)
      });
};

function setColorOfRainfall(rainfall: number): string {
  switch (true) {
    case (rainfall >= 150.0):
      return "black";
    case (rainfall >= 100.0):
      return "purple";
    case (rainfall >= 70.0):
      return "orange";
    case (rainfall >= 50.0):
      return "red";
    case (rainfall >= 20.0):
      return "yellow";
    default:
      return "gray"; //gray
  }
}

function setColorOfRainfallText(rainfall: number): string {
  switch (true) {
    case (rainfall >= 150.0):
        return "white";
    case (rainfall >= 100.0):
        return "white";
    case (rainfall >= 70.0):
        return "black";
    case (rainfall >= 50.0):
        return "white";
    case (rainfall >= 20.0):
        return "black";
    default:
        return "white";
  }
}

function setRainMarkerIconSize(rainfallStr: string): Leaflet.PointExpression {
    switch (true) {
        case (rainfallStr?.length === 1):
            return [21, 25];
        case (rainfallStr?.length === 2):
            return [25, 25];
        case (rainfallStr?.length >= 3):
            return [30, 25];
        default:
            return [21, 25];
    }
}